<template lang='pug'>
  include /mixins
  +b.relative
    slot(
      v-if='show',
      :focus='() => focus()',
    )
    controller.relative(
      v-if='!show',
      :localsearch='search'
      :searchResource='$options.searchV3Resource'
      :preview='$options.preview'
      ref='visibleinput'
      :id='$attrs.id'
    )
      template(#inputview='{ keyupEvent, goToSearch, reset, trigger_overlay, activeSearch }')
        .control-stack
          .relative.search-form--variant_header
            +b.search-trigger.--left.--fixed-width.BUTTON(
              :aria-label=`_('Поиск')`
            )
              +e.loop.icon-search
            transition(name="fade")
              +b.d-control-input--appearance_bordered.D-CONTROL-INPUT(
                type='search',
                :placeholder='placeholder',
                v-model='search',
                autocomplete='125выпывпфывп'
                ref='search-input'
                @keyup="keyupEvent",
                @search="test(reset, trigger_overlay)",
              )
</template>
<script>
import { mapState } from 'vuex'
import { SEACRH_V3_URL } from '@api/vendor.service'
import ProductPreview from '@app/Search-v3/Ui/Product'
import Controller from './Controller'

const preview = ProductPreview

export default {
  name: 'SearchView',
  props: ['className', 'fieldId', 'url'],

  components: {
    Controller,
    ProductPreview,
  },
  preview,
  searchV3Resource: SEACRH_V3_URL,

  data() {
    return {
      show: true,
      search: '',
      placeholder: this._('Я ищу...'),
    }
  },
  watch: {
    global_search(nval) {
      this.search = nval
    },
  },

  computed: {
    ...mapState('search', [
      'global_search',
    ]),
  },

  mounted() {
    this.$store.subscribe(mutation => {
      if ('search/SET_SEARCH' == mutation.type) {
        this.search = mutation.payload
      }
    })
  },
  methods: {
    test(fn, rm_overlay) {
      if (!this.search) {
        fn()
        rm_overlay()
      }
    },
    focus() {
      this.show = false
      this.$nextTick(() => {
        const parent = this.$refs.visibleinput
        let [input] = parent.$children
        console.dir(input);
        input = input.$children[0].$children[0].$children[0].$refs.input

        if (input.focus) {
          input.focus()
          return
        }
        input.$el.focus()
      })
    },
  },
}

</script>
